import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/layout/scrollTop/scrollToTop";

import Main from "./containers/main";
import UploadDocument from "./containers/uploadId";
import SignDocuments from "./containers/signDocuments";
import DocumentView from "./containers/document";
import MakeClaimMailReferral from "./containers/makeClaimMailReferral";
import SignDocumentsMailReferral from "./containers/signDocumentsMailReferral";

export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<MakeClaimMailReferral />} />
                    <Route path="sign/:token" element={<SignDocumentsMailReferral />} />
                    <Route path="claim/sign-sentinel-cfa/:token" element={<SignDocuments docsToSign="sentinel-cfa" />} />
                    <Route path="upload-id/:token" element={<UploadDocument />} />
                    <Route path="documents/:fileName" element={<DocumentView />} />
                </Route>
            </Routes>
        </Router>
    );
}
